/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.15.0
 */

import { IWizardBillsDocOrderResult } from '../types/wizardBillsDocTypes';

export const wizardBillsDocOrderResultHasError = (orderResult?: IWizardBillsDocOrderResult): boolean =>
    !!orderResult &&
    !!(orderResult.actsErrorCount
        || orderResult.billsErrorCount
        || orderResult.fuctsErrorCount
        || orderResult.invoicesErrorCount
    );

export const wizardBillsDocOrderResultHasSuccess = (orderResult?: IWizardBillsDocOrderResult): boolean =>
    !!orderResult &&
    (orderResult.actsCount > 0
        || orderResult.billsCount > 0
        || orderResult.fuctsCount > 0
        || orderResult.invoicesCount > 0
    );
